const eventsData = [
	{
		id: 1,
		image: "./generalPage/1.webp",
		title: "Social activities",
		description:
			"Join our community garden project and learn about sustainable farming practices.",
		date: "May 25",
		event: "Social activities",
	},

	{
		id: 2,
		image: "./generalPage/2.webp",
		title: "Social activities",
		description:
			"Volunteer for a local river cleanup to protect aquatic ecosystems.",
		date: "May 31",
		event: "Social activities",
	},

	{
		id: 3,
		image: "./generalPage/3.webp",
		title: "Social activities",
		description:
			"Attend a workshop on eco-friendly home gardening techniques.",
		date: "Jul 12",
		event: "Social activities",
	},

	{
		id: 4,
		image: "./generalPage/4.webp",
		title: "Social activities",
		description:
			"Participate in a community bike ride to promote sustainable transportation.",
		date: "Jun 20",
		event: "Social activities",
	},

	{
		id: 9,
		image: "./generalPage/9.webp",
		title: "Social activities",
		description:
			"Join a group discussion on reducing plastic waste in daily life.",
		date: "Oct 5",
		event: "Social activities",
	},

	{
		id: 5,
		image: "./generalPage/5.webp",
		title: "Social events",
		description:
			"Celebrate World Environment Day with a green-themed picnic in the park.",
		date: "Dec 5",
		event: "Social events",
	},

	{
		id: 6,
		image: "./generalPage/6.webp",
		title: "Social events",
		description:
			"Enjoy a documentary screening night focused on sustainability and conservation efforts.",
		date: "May 15",
		event: "Social events",
	},

	{
		id: 7,
		image: "./generalPage/7.webp",
		title: "Social events",
		description:
			"Join a community potluck dinner featuring locally sourced, organic dishes.",
		date: "Jul 20",
		event: "Social events",
	},

	{
		id: 8,
		image: "./generalPage/8.webp",
		title: "Social events",
		description:
			"Participate in a clothing swap event to promote sustainable fashion practices.",
		date: "Aug 10",
		event: "Social events",
	},

	{
		id: 10,
		image: "./generalPage/10.webp",
		title: "Social events",
		description:
			"Experience a sustainable living expo showcasing innovative eco-friendly products.",
		date: "Sep 30",
		event: "Social events",
	},

	{
		id: 11,
		image: "./generalPage/11.webp",
		title: "Social events",
		description:
			"Attend a community beach cleanup followed by a bonfire and stargazing session.",
		date: "Nov 15",
		event: "Social events",
	},

	{
		id: 12,
		image: "./generalPage/12.webp",
		title: "Social events",
		description:
			"Join a group hike in a local nature reserve to appreciate biodiversity.",
		date: "No Yet Scheduled",
		event: "Social events",
	},
];

export default eventsData;
